module.exports = __webpack_public_path__ + "static/media/csv.a47e588e.svg";